<!--This is for testing purpose where image is loading a little late after clearing cache-->
<div *ngIf="isIconShown && iconSource" [ngStyle]="{'background-color': color, 'min-width':messageLength+'px'}" class="toastr-class">
   <span class="icon-success"><img [src]=iconSource alt=""/></span> 
   <span id="toast" class="message">{{(message | translate) ? (message | translate): message}} </span>
</div>
